export default "data:image/webp;base64,UklGRkoAAABXRUJQVlA4ID4AAADQAQCdASoQAAkAAsBMJQBOgCHTDClSIAD+90IrTDOGL62WGZdr77Zi/sFzXVY5H5A3JI1lFH3y64N1mAAAAA==";